module.exports = __webpack_public_path__ + "static/media/romanticos_feminino_beleza.abcae9ea.jpg";